export enum UserRole  {
    UNKNOWN_ROLE =  0,
    AUTHENTICATED_USER =  2,
    SNHUB_ANONYMOUS_USER =  4
}
